import { render, staticRenderFns } from "./roleFrom.vue?vue&type=template&id=7c2f0bd8&scoped=true"
import script from "./roleFrom.vue?vue&type=script&lang=js"
export * from "./roleFrom.vue?vue&type=script&lang=js"
import style0 from "./roleFrom.vue?vue&type=style&index=0&id=7c2f0bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2f0bd8",
  null
  
)

export default component.exports